import HelpComponent from '../components/help/help'

const Help = () => <HelpComponent />

export default Help;